import { Box, Button, Grid, Grid2, IconButton, MenuItem, Paper, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import Navbar from "../navbar/Navbar";
import Sidemenu from "../sidemenu/Sidemenu";
import { useEffect, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { Label } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import TokenError from "../tokenError";
import { parsePhoneNumber } from 'libphonenumber-js';
import PhoneInput from 'react-phone-number-input';

var constants = require('../../constant');

const Corporate = () => {
    const [cityFilter, setCityFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [open, setOpen] = useState(false);
    const [editable, setEditable] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [nameError, setNameError] = useState(false);
    const [accounterror , setAccountError] = useState(false);
    const [phoneError , setPhoneError] = useState(false);
    const [debtError , setDebtError] = useState(false);
    const [vatError , setVatError] = useState(false);
    const [statusError , setStatusError] = useState(false);
    const [rideLimitError , setRideLimitError] = useState(false);
    const [transactionLimitError , setTransactionLimitError] = useState(false);
    const [paymentMethodError , setPaymentMethodError] = useState(false);
    const [countryCode, setCountryCode] = useState('');
    const [rows, setRows] = useState([]);
    const [corpId, setCorpId] = useState(0);
    const [corpName, setCorpName] = useState('');
    const [monthlyRideLimit, setMonthlyRideLimit] = useState('');
    const [monthlyTransactionLimit, setMonthlyTransactionLimit] = useState('');
    const [allowedPaymentMethods, setAllowedPaymentMethods] = useState("");
    const [corpStatus, setCorpStatus] = useState('Active');
    const [accountNumber, setAccountNumber] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [debtLimit, setDebtLimit] = useState('');
    const [vatNumber, setVatNumber] = useState('');
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    console.log(corpName,"corpname")
    const handleFilterChange = (filterType, value) => {
        if (filterType === 'city') setCityFilter(value);
        if (filterType === 'status') setStatusFilter(value);
    };

    const handleOpenAddCorporate = () => {
        setOpen(true);
        setEditable(false);
        setCorpName('');
        setMonthlyRideLimit('');
        setMonthlyTransactionLimit('');
        setAllowedPaymentMethods('');
        setCorpStatus('Active');
        setCorpId(0);
        setAccountNumber('');
        setPhoneNumber('');
        setEmail('');
        setDebtLimit('');
        setVatNumber('');
        setEmailError(false);
        setNameError(false);
        setAccountError(false);
        setPhoneError(false);
        setDebtError(false);
        setVatError(false);
        setPaymentMethodError(false);
        setStatusError(false);
        setRideLimitError(false);
        setTransactionLimitError(false);
    }

    const validateEmail = (email) => {
        const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return re.test(String(email).toLowerCase());
    };

    const handleOpenEditCorporate = (row) => {
        setCorpName(row.name);
        setMonthlyRideLimit(row.monthly_ride_limit);
        setMonthlyTransactionLimit(row.monthly_transaction_limit);
        setAllowedPaymentMethods(row.allowed_payment_methods);
        setCorpStatus(row.status==0 ? 'Inactive': 'Active');
        setCorpId(row.id);
        setOpen(true);
        setEditable(true);
        setAccountNumber(row.account_number);
        setPhoneNumber(row.phone_number);
        setEmail(row.email);
        setDebtLimit(row.debt_limit);
        setVatNumber(row.vat_number);
        setEmailError(false);
        setNameError(false);
        setAccountError(false);
        setPhoneError(false);
        setDebtError(false);
        setVatError(false);
        setPaymentMethodError(false);
        setStatusError(false);
        setRideLimitError(false);
        setTransactionLimitError(false);

    }

    const handleClose = () => {
        setOpen(false);
        setEditable(false);
    }

    const fetchCorporateData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/corporates/fetch_all';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchCorporateData();
    },[])

    const handleReset = () => {
        setCorpName('');
        setMonthlyRideLimit('');
        setMonthlyTransactionLimit('');
        setAllowedPaymentMethods('');
        setCorpStatus('');
        setCorpId(0);
        setAccountNumber('');
        setPhoneNumber('');
        setEmail('');
        setDebtLimit('');
        setVatNumber('');
        setEmailError(false);
        setNameError(false);
        setPhoneError(false);
        setDebtError(false);
        setVatError(false);
        setPaymentMethodError(false);
        setStatusError(false);
        setRideLimitError(false);
        setTransactionLimitError(false);

    }

    console.log(rows,"row")

    const handleSubmit = async() =>{
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            name: corpName,
            monthly_ride_limit: monthlyRideLimit,
            monthly_transaction_limit: monthlyTransactionLimit,
            allowed_payment_methods: allowedPaymentMethods,
            status: corpStatus === "Inactive" ? 0 : 1,
            account_number: accountNumber,
            phone_number: phoneNumber,
            email: email,
            debt_limit: debtLimit,
            vat_number: vatNumber,
          };
          
        if(editable && corpId!=0){
            payload.corporate_id = corpId;
        }

        if (email && !validateEmail(email)) {
            setEmailError(true);
            setMessage('Please enter a valid email address');
            showSnackbar(true);
            return;
        }

        if(corpName == ""){
            setNameError(true);
            setMessage('Please enter a valid name');
            showSnackbar(true);
            return;
        }

        if(accountNumber == ""){
            setAccountError(true);
            setMessage('Please enter a valid account number');
            showSnackbar(true);
            return;
        }

        if(phoneNumber == ""){
            setPhoneError(true);
            setMessage('Please enter a valid phone number');
            showSnackbar(true);
            return;
        }

        if(debtLimit == ""){
            setDebtError(true);
            setMessage('Please enter a valid debt limit');
            showSnackbar(true);
            return;
        }

        if(vatNumber == ""){
            setVatError(true);
            setMessage('Please enter a valid vat number');
            showSnackbar(true);
            return;
        }

        if(allowedPaymentMethods == ""){
            setPaymentMethodError(true);
            setMessage('Please enter a valid payment method');
            showSnackbar(true);
            return;
        }

        if(corpStatus == ""){
            setStatusError(true);
            setMessage('Please enter a valid status');
            showSnackbar(true);
            return;
        }

        if(monthlyRideLimit == ""){
            setRideLimitError(true);
            setMessage('Please enter a valid monthly ride limit');
            showSnackbar(true);
            return;
        }

        if(monthlyTransactionLimit == ""){
            setTransactionLimitError(true);
            setMessage('Please enter a valid monthly transaction limit');
            showSnackbar(true);
            return;
        }

        try {
            const url = operationsUrl + '/corporates/add_update_corporates';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);

            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }

        handleClose(); // Close the modal after saving
        fetchCorporateData();

    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };
    return(
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Corporate
            </Typography>

            {/* Filters */}
            <Grid2 item container spacing={2} alignItems="center" sx={{ marginTop: '2%', marginBottom: '2%' }}>

                <Grid2 item>
                    <Select
                        value={statusFilter}
                        onChange={(e) => handleFilterChange('status', e.target.value)} displayEmpty
                        style={{width: '220px', height: '50px', borderRadius: '8px', backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Status</MenuItem>
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Button
                        variant="contained" onClick={handleOpenAddCorporate}
                        style={{width:'185px',height: '50px',backgroundColor:'#000000',textTransform:'none',borderRadius:'8px'}}>
                        + Add Corporate
                    </Button>
                </Grid2>
            </Grid2>

            {/* add - edit modal */}
            {open && (
                <div
                style={{
                  position: 'fixed',
                  top: 65,
                  right: 0,
                  height: 'calc(100vh - 65px)',
                  width: '50%',
                  backgroundColor: '#f9f9f9',
                  boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                  transition: 'right 0.3s ease-in-out',
                  zIndex: 1000,
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1, overflowY: 'auto', padding: 20
                }}
              >
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                                    {editable ? 'Edit Corporate' : 'Add Corporate'}
                                </Typography>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Label>Name<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Name" fullWidth variant="outlined" type="text" value={corpName} error={nameError}
                                            helperText={nameError ? 'Please enter a valid name' : ''}
                                            required
                                            onChange={(e) => {setCorpName(e.target.value); setNameError(false)}}
                                            InputProps={{
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Account Number<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Account Number" fullWidth variant="outlined" type="number" value={accountNumber} error={accounterror}
                                            helperText={accounterror ? 'Please enter a valid account number' : ''}
                                            onChange={(e) => {setAccountNumber(e.target.value); setAccountError(false)}}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Phone Number<span style={{ color: 'red' }}>*</span></Label>
                                        {/* <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Phone Number" fullWidth variant="outlined" type="number" value={phoneNumber} error={phoneError}
                                            helperText={phoneError ? 'Please enter a valid phone number' : ''}
                                            onChange={(e) => {setPhoneNumber(e.target.value); setPhoneError(false)}}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        /> */}
                                        <PhoneInput
                                            defaultCountry="IN"
                                            value={phoneNumber}
                                            onChange={(value) => {
                                            setPhoneNumber(value);
                                            try {
                                                const parsed = parsePhoneNumber(value);
                                                if (parsed) {
                                                setCountryCode(parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '');
                                                }
                                            } catch (err) {
                                                console.error('Invalid phone number:', err);
                                                setCountryCode('');
                                            }
                                            }}
                                            placeholder="Enter phone number"
                                            style={{
                                            height: '48px',
                                            fontSize: '16px', borderRadius:'8px',
                                            alignItems: 'normal', marginTop:'2%'
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Email<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Email" fullWidth variant="outlined" type="email" value={email} error={emailError}
                                            helperText={emailError ? 'Please enter a valid email address' : ''}
                                            onChange={(e) => {setEmail(e.target.value); setEmailError(false)}}
                                            InputProps={{
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Monthly Ride Limit<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Monthly Ride Limit" fullWidth variant="outlined" type="number" value={monthlyRideLimit} error={rideLimitError}
                                            helperText={rideLimitError ? 'Please enter a valid monthly ride limit' : ''}
                                            onChange={(e) => {setMonthlyRideLimit(e.target.value); setRideLimitError(false)}}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Monthly Trans Limit<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Monthly Transaction Limit" fullWidth variant="outlined" type="number" value={monthlyTransactionLimit} error={transactionLimitError}
                                            helperText={transactionLimitError ? 'Please enter a valid monthly transaction limit' : ''}
                                            onChange={(e) => {setMonthlyTransactionLimit(e.target.value); setTransactionLimitError(false)}}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Allowed Payment Methods<span style={{ color: 'red' }}>*</span></Label>
                                        <Select sx={{marginTop:'2%'}}
                                            value={allowedPaymentMethods} fullWidth error={paymentMethodError}
                                            helperText={paymentMethodError ? 'Please select a valid payment method' : ''}
                                            onChange={(e) => {setAllowedPaymentMethods( e.target.value); setPaymentMethodError(false)}}
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                                            
                                                {Object.entries(constants.paymentMethod2).map(([id, label]) => (
                                                    <MenuItem key={id} value={id}>
                                                        {label}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Status<span style={{ color: 'red' }}>*</span></Label>
                                        <Select sx={{marginTop:'2%'}}
                                            value={corpStatus} fullWidth error={statusError}
                                            helperText={statusError ? 'Please select a valid status' : ''}
                                            onChange={(e) => {setCorpStatus( e.target.value); setStatusError(false)}}
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                                            <MenuItem value="">Status</MenuItem>
                                            <MenuItem value="Active">Active</MenuItem>
                                            <MenuItem value="Inactive">Inactive</MenuItem>
                                        </Select>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Debt Limit<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Debt Limit" fullWidth variant="outlined" type="number" value={debtLimit} error={debtError}
                                            helperText={debtError ? 'Please enter a valid debt limit' : ''}
                                            onChange={(e) => {setDebtLimit(e.target.value); setDebtError(false)}}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Vat Number<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Vat Number" fullWidth variant="outlined" type="text" value={vatNumber} error={vatError}
                                            helperText={vatError ? 'Please enter a valid vat number' : ''}
                                            onChange={(e) => {setVatNumber(e.target.value); setVatError(false)}}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>
                                </Grid>

                                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        sx={{width: '140px',height: '50px',textTransform: 'none',
                                            fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                        {editable ? 'Update' : 'Save'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleReset}
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            textTransform: 'none',
                                            fontSize: '16px',
                                            backgroundColor: '#F0F0F0',
                                            color: '#B0B0B0',
                                        }}
                                    >
                                        Reset
                                    </Button>
                                </div>
                            </Paper>

                        </div>
                    </Box>
                </div>
            )}

            <TableContainer className="table-container" sx={{ maxHeight:'70vh' }}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Name</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Monthly Ride Limit</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Monthly Transaction Limit</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Allowed Payment Methods</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Account Number</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Phone Number</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Email</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Debt Limit</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Vat Number</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows.filter((row) => {
                            const isStatusMatch = statusFilter ? (statusFilter === 'Active' ? row.status === 1 : row.status === 0) : true;
                            return isStatusMatch;
                        })
                        .map((row) => {
                            const payment = constants.paymentMethod2[row.allowed_payment_methods]

                            return(
                                <TableRow key={row.id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.name ? (row.name) : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.monthly_ride_limit ? (row.monthly_ride_limit) : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.monthly_transaction_limit ? (row.monthly_transaction_limit) : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{payment ? (payment) : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.account_number ? (row?.account_number): "--"}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.phone_number ? (row.phone_number) : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.email ? (row.email) : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.debt_limit ? (row.debt_limit) : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.vat_number ? (row.vat_number) : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color: row.status === 1 ? '#0DBA78' : '#D14545', fontWeight:'500' }}>{row.status==1 ? 'Active' : 'Inactive'}</Typography></TableCell>
                                    <TableCell align="center">
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEditCorporate(row)}
                                            sx={{
                                                backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                                '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                            }}>
                                            
                                            <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                                <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                            </svg>
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            
            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>
    )
}

export default Corporate;